import mutationsTypes from '@/vuex/documento/mutations-types.js'
const types = {
  ...mutationsTypes,
  GET_DOCUMENTO: 'GET_DOCUMENTO',
  GET_PRESENTE_CAIXA_POSTAL: 'GET_PRESENTE_CAIXA_POSTAL',
  GET_RAIZ_PRESENTE_CAIXA_POSTAL: 'GET_RAIZ_PRESENTE_CAIXA_POSTAL',
  GET_EMAIL_INTERESSADO: 'GET_EMAIL_INTERESSADO',
  SET_EMAIL_INTERESSADO: 'SET_EMAIL_INTERESSADO',
  RECEBER_DOCUMENTO: 'RECEBER_DOCUMENTO',
  GET_URL_CONSOLIDACAO: 'GET_URL_CONSOLIDACAO',
  GET_PDF_CAPA: 'GET_PDF_CAPA',
  GET_PDF_COMPROVANTE_PROTOCOLIZACAO: 'GET_PDF_COMPROVANTE_PROTOCOLIZACAO',
  ENVIAR_COMPROVANTE_PROTOCOLIZACAO_POR_EMAIL: 'ENVIAR_COMPROVANTE_PROTOCOLIZACAO_POR_EMAIL',
  CONFIRMAR: 'ui/CONFIRMAR',
  SALVAR_TAGS: 'SALVAR_TAGS',
  FAVORITAR_DOCUMENTO: 'FAVORITAR_DOCUMENTO',
  DESFAVORITAR_DOCUMENTO: 'DESFAVORITAR_DOCUMENTO',
  GET_CONSOLIDACOES: 'GET_CONSOLIDACOES'
}

export default types
